import { Tooltip, TooltipProps } from "@mui/material"
import styles from './CustomTooltip.module.css'

export const CustomTooltip = ({ classes, ...rest }: TooltipProps) => (
  <Tooltip
    {...rest}
    classes={{ tooltip: styles.tooltip, ...classes }}
  />
)
